import { PlusIcon } from "@heroicons/react/20/solid";


export const QualityReferences = ({ referencesIds, selectedReferenceId, onSelectReference, createReference }) => {

  return (
    <div className="absolute top-4 right-4 w-24 bg-black/20 backdrop-blur-lg rounded-md flex flex-col items-center gap-2 p-2">
      {
        referencesIds.map((referenceId) => {
          const url = process.env.REACT_APP_ADDRESS + 'public/media/references/' + referenceId + '_resized.jpg';
          const borderColor = referenceId === selectedReferenceId ? 'border-perception-blue' : 'border-white';
          return (
            <div
              key={referenceId}
              className={`size-20 rounded-md overflow-hidden bg-cover bg-center bg-no-repeat border-3 ${borderColor}`}
              style={{ backgroundImage: `url(${url})` }}
              onClick={() => onSelectReference(referenceId)}
            />
          )
        })
      }
      <div
        className="size-20 rounded-md overflow-hidden bg-white flex flex-col justify-center items-center text-center text-xs"
        onClick={createReference}
      >
        <PlusIcon className="size-6"/>
        Nouvelle référence
      </div>
    </div>
  );
};